import { Component, Input, OnInit } from '@angular/core';
// import { Auth } from '../../auth/auth.service';
import { HttpClient } from '@angular/common/http';
import {CommonDataService} from './../common-data.service';

@Component({
	selector: 'app-fs-icon',
	templateUrl: './fs-icon.component.html',
	styleUrls: ['./fs-icon.component.scss']
})
export class FsIconComponent implements OnInit {

	@Input() profile;

  constructor(public http: HttpClient, public service:CommonDataService ) { }

	ngOnInit() {}

	get profileLabel(): string {
		const labels = {
			1: 'Clarifier', 2: 'Ideator', 3: 'Developer', 4: 'Implementer',
			5: 'Early Bird', 6: 'Analyst', 7: 'Accelerator', 8: 'Theorist',
			9: 'Driver', 10: 'Finisher', 11: 'Hare', 12: 'Idea Broker',
			13: 'Optimist', 14: 'Integrator', 15: 'Realist'
		};
		return labels[+this.profile?.profile_type_id] || '';
	}

}
